import { Model } from "@vuex-orm/core";
import Location from "./Location";
import { required, maxLength, decimal } from "vuelidate/lib/validators";
import { RawMeasurement } from "./Measurement";
import Material from "./Material";
import BatchRawOrigin from "./BatchRawOrigin";

export default class RawMaterial extends Model {
  static entity = "rawmaterials";

  static $fetch() {
    return this.api().get('RawMaterials/')
  }
  static $fetchActive() {
    return this.api().get('RawMaterials/?archived=false')
  }
  static $fetchByMaterial(id) {
    return this.api().get(`RawMaterials/?material=${id}&archived=false`)
  }
  static $get (id) {
    return this.api().get(`RawMaterials/${id}/`)
  }
  static $post (data) {
    return this.api().post(`RawMaterials/`, data)
  }
  static $put (id, data) {
    return this.api().put(`RawMaterials/${id}/`, data)
  }
  static $patch (id, data) {
    return this.api().patch(`RawMaterials/${id}/`, data)
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string("Descript Name"),
      notes: this.string(""),
      icon: this.string("grain"),
      barcode: this.string("Placeholder"),
      barcodeIcon: this.string("fas fa-barcode"),
      lotnumber: this.string("Lot321"),
      lotnumberIcon: this.string("fas fa-qrcode"),
      original: this.string("100"),
      quantity: this.string("100"),
      units: this.string("g"),
      location: this.belongsTo(Location, "location_id"),
      location_id: this.attr(null),
      archived: this.boolean(false),
      measurements: this.hasMany(RawMeasurement, "rawmaterial_id"),
      sources: this.hasMany(BatchRawOrigin, "rawmaterial_id"),
      material: this.belongsTo(Material, "material_id"),
      material_id: this.attr(null)
    };
  }

  get display_name() {
    return `${this.barcode} ${this.name}`;
  }

  toCreatePayload() {
    return {
      name: this.name,
      barcode: this.barcode,
      original: this.original,
      quantity: this.quantity,
      units: this.units,
      material: this.material_id,
      location: this.location_id,
      archived: this.archived,
      notes: this.notes,
      lotnumber: this.lotnumber
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }

  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(48) },
        lotnumber: { required, maxLength: maxLength(48) },
        original: { required, decimal, maxLength: maxLength(13) },
        quantity: { required, decimal, maxLength: maxLength(13) },
        units: { required },
        location_id: { required }
      }
    };
  }
}

